import React from 'react';
import type { CFMedia, CFSeqFrame, CFText, CFVideo } from '@types';
import { Collapse } from '@components/Collapse';
import Input from '@components/Input';
import useInputHandlers from '@hooks/useInputHandelrs';
import { useCustomFeature } from '../CustomFeatureContext';
import LinkSetting from '../components/LinkSetting';

function CMoreLinkSetting() {
  const { data, setData } = useCustomFeature<
    CFMedia | CFText | CFVideo | CFSeqFrame
  >();
  const titleHandlers = useInputHandlers((val) =>
    setData((draft) => {
      draft.linkTitle = val;
    })
  );

  return (
    <Collapse title="更多内容" isHideDefault>
      <Input
        scheme="dark"
        className="mb-10 h-30"
        maxLength={10}
        placeholder="请输入链接名称"
        value={data.linkTitle}
        {...titleHandlers}
      />
      <LinkSetting
        value={data.linkUrl}
        linkTarget={data.openMethod}
        modalSizeType={data.modalSizeType}
        size={data.size}
        onChange={(val) =>
          setData((draft) => {
            draft.linkUrl = val;
          })
        }
        onTargetChange={(k) => {
          setData((draft) => {
            draft.openMethod = k;
          });
        }}
        onModalSizeTypeChange={(k) => {
          setData((draft) => {
            draft.modalSizeType = k;
          });
        }}
        onModalSizeChange={(val) => {
          setData((draft) => {
            draft.size = val;
          });
        }}
      />
    </Collapse>
  );
}

export default CMoreLinkSetting;
